import { readItem, readItems } from "@directus/sdk";
import getClient from "./ApiClient";

export interface Place {
  id: string | number;
  name?: string;
  code?: string;
  [key: string]: unknown;
}

export function getPlaceCode(place: Place): string {
  if (typeof place.code === "string" && place.code.trim().length > 0) {
    return place.code;
  }

  if (typeof place.code === "number") {
    return String(place.code);
  }

  return String(place.id);
}

export async function getPlaces(): Promise<Place[]> {
  const authenticatedClient = await getClient();
  const response = await authenticatedClient.request(readItems("places", {
    fields: ["*"],
  }));

  return response as Place[];
}

export async function getPlace(id: string | number): Promise<Place> {
  const authenticatedClient = await getClient();
  const response = await authenticatedClient.request(
    readItem("places", id, {
      fields: ["*"]
    })
  );

  return response as Place;
}

export async function getPlaceByCode(code: string): Promise<Place | null> {
  const trimmedCode = code.trim();
  if (!trimmedCode) {
    return null;
  }

  const authenticatedClient = await getClient();
  const response = await authenticatedClient.request(
    readItems("places", {
      fields: ["*"],
      filter: {
        code: {
          _eq: trimmedCode
        }
      },
      limit: 1
    })
  );

  const places = response as Place[];
  return places.length > 0 ? places[0] : null;
}

export default getPlaces;
